// extracted by mini-css-extract-plugin
export var leftAlign = "_s-2";
export var popper = "_s-0";
export var subtitle = "_s-1";